<template>
    <div  :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" style="margin-top: 6px">
        <img src="@/assets/images/other-icons/error.png" v-if="errorMail"/>
    </div>
</template>

<script>
export default {
  name: 'CellRendererError',
  data(){
      return{
          errorMail : false,
      }
  },
  methods:{
      isShowImg(params){
        this.errorMail = params.data.error_detail ? true : false;
      }
  },
  created(){
      this.isShowImg(this.params);
  }
}
</script>